import React from "react"

const Contacto =()=>{
    return(
        <h1>Contacto</h1>
    )
}
export default Contacto